import React from 'react';

const PolygonIcon = (props) => (
  <svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="30" height="20" rx="2" fill="#6C00F6"/>
    <g clipPath="url(#clip0_6867_4623)">
      <path d="M13.0704 7.75652L11.6182 6.91304L7.26172 9.44348V14.487L11.6182 17.0087L15.9748 14.487V6.64348L18.3922 5.24348L20.8095 6.64348V9.44348L18.3922 10.8435L16.94 10V12.2435L18.3922 13.087L22.7487 10.5652V5.52174L18.3922 3L14.0356 5.52174V13.3652L11.6182 14.7652L9.20085 13.3652V10.5565L11.6182 9.15652L13.0704 10V7.75652Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_6867_4623">
        <rect width="15.4783" height="14" fill="white" transform="translate(7.26172 3)"/>
      </clipPath>
    </defs>
  </svg>
);

export default PolygonIcon;
